import useHashParam from 'use-hash-param';

export const useCompanyQuerystringParams = () => {
  const [companyId, setCompanyId] = useHashParam('companyId', '');
  return {
    companyId,
    setCompanyId,
  };
};
